import { render, staticRenderFns } from "./LeftNavbarComponent.vue?vue&type=template&id=2037256b&"
import script from "./LeftNavbarComponent.vue?vue&type=script&lang=js&"
export * from "./LeftNavbarComponent.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavbarComponent.vue?vue&type=style&index=0&id=2037256b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports